import React from "react";
import profileImagePlaceholder from "../../assets/images/AdvisorProfileImage.png";
import tagSEBI from "../../assets/images/sebi-tag.svg";
import ReactReadMoreReadLess from "react-read-more-read-less";

const AboutAdvisor = ({ firstName, lastName, SEBIRegNo, content }) => {
  
  return (
    <div className="p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 mb-8">
        <div className="hidden lg:block flex-shrink-0">
          <img
            src={profileImagePlaceholder}
            width={256}
            height={256}
            className="rounded-2xl"
            alt="Advisor profile"
          />
        </div>
        <div className="flex-1">
          <div className="mb-4">
            <h2 className="text-xl lg:text-2xl font-semibold text-[#333] mb-3 capitalize">
              Meet Our Expert:{" "}
              <span className="uppercase">
                {firstName} {lastName}
              </span>
            </h2>
            <div className="flex items-center gap-2 mb-4">
              <img src={tagSEBI} alt="SEBI" className="w-auto h-auto" />
              <span className="text-sm lg:text-base text-[#454545]">
                {SEBIRegNo}
              </span>
            </div>
          </div>

          <div className="text-base lg:text-lg text-[#454545] leading-relaxed mb-4">
            <ReactReadMoreReadLess
              charLimit={250}
              readMoreText={"Read More..."}
              readLessText={"Read Less..."}
            >
              {content ?? ""}
            </ReactReadMoreReadLess>
          </div>
          <div className="text-base lg:text-lg text-[#333] font-medium underline cursor-pointer hover:text-primary transition-colors">
            View Disclosure
          </div>
        </div>
      </div>
      <div className="text-xs lg:text-sm text-[#999] leading-relaxed">
        <span className="font-medium">Disclaimer :</span> Investing in
        Stocks/ETFs (Exchange Traded Funds) are subject to market risks. Read
        all the related documents before investing. Investors should consider
        all risk factors and consult their financial advisor before investing
      </div>
    </div>
  );
};

export default AboutAdvisor;
